export default class DomComponent 
{

	constructor(settings = {})
	{
		this.settings = settings;
	}

	hasSetting(attribute)
	{
		return this.settings.hasOwnProperty(attribute);
	}

	$el(prop) 
	{
		const el = this.settings[prop]; 
		if (!el) {
			throw new Error('Property ' + prop.toUpperCase() + ' not found');
		}
		return $(el);
	}

}